import { render, staticRenderFns } from "./ProjetoDialog.vue?vue&type=template&id=b76d20fe&"
import script from "./ProjetoDialog.vue?vue&type=script&lang=js&"
export * from "./ProjetoDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoDialog.vue?vue&type=style&index=0&id=b76d20fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports